import React from 'react'
import UploadForm from '../components/UploadForm'
import TypingHeadline from '../components/TypingHeadline'
import pepperImg from '../assets/img/hero_peper_sredina.png';
import logoHeader from '../assets/img/preSavremena_SOS.svg';
import logoHeaderWhite from '../assets/img/logo_sos_sg_white_co.svg';
import akreditacije from '../assets/img/Camb_mpn.webp';
import bacground_mob from '../assets/img/pepper-hero-background-mob_1.jpg';
import kakoDa1 from '../assets/img/pepper_1.jpg'
import kakoDa2 from '../assets/img/pepper_2.jpg'
import kakoDa3 from '../assets/img/pepper_3.jpg'
import kakoDa4 from '../assets/img/pepper_4.jpg'
import kakoDa5 from '../assets/img/pepper_5.jpg'

import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import EmojiSymbolsIcon from '@mui/icons-material/EmojiSymbols';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

const Home = () => {
  return (
    <>
    <div className="home-hero">
        {/* <div className="hero-opacity"></div> */}
        <div className="navbar">
          <img src={logoHeader} alt="logoSOS" className='logoHeader'/>
          <img src={akreditacije} alt="akreditacije" className='akreditacije'/>
        </div>
        <div className="container">
          <div className="content">
            <div className="tagname">
              <div className="free">
                <span className='free-text'>BESPLATNO</span>
              </div>
              <div className="dugmence">
                <TipsAndUpdatesIcon />
                  <span>Pepper AI analiza crteža</span>
              </div>
              
              <h1>Šta crtež vašeg deteta govori o njemu?</h1>
              <h2>Najsavremeniji robot-nastavnik Pepper, analizira crtež vašeg deteta i otkriva njegove jedinstvene osobine, emocije i talente.</h2>
            </div>
            <img src={bacground_mob} alt="" />
            <TypingHeadline />
            
            <h2 className='heading-elements-box'>Uz brzu, jednostavnu i besplatnu analizu: </h2>
            <div className="box-elements">
              <div className="box-1">
                <div className="icon-element"><EmojiSymbolsIcon className='icon-1'/></div>
                <div className="text-box">
                  <p><strong>Otkrijte</strong></p>
                  <p>osobine i potencijal svog deteta.</p>
                </div>
              </div>
              <div className="box-2">
                <div className="icon-element"><FavoriteBorderIcon className='icon-2'/></div>
                <div className="text-box">
                  <p><strong>Upoznajte</strong></p>
                  <p>njegov emotivni svet i zrelost.</p>
                </div>
              </div>
              <div className="box-3">
                <div className="icon-element"><Diversity1Icon className='icon-3'/></div>
                <div className="text-box">
                  <p><strong>Prepoznajte</strong></p>
                  <p>kako najbolje da ga podržite.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-img-box">
            <UploadForm />
          </div>
        </div>
        

    </div>
    <div className="section-1">
      <h2>Kako do Pepperove analize crteža?</h2>

      <div className="steps-content">

        <div className="steps step-1">
          <h3 className="steps-heading-1">
            1. Izaberite neki crtež vašeg deteta
          </h3>
          <div className="img-box">
            <img src={kakoDa1} alt="" />
          </div>
        </div>

        <div className="steps step-2">
          <h3 className="steps-heading-2">
            2. Pošaljite crtež i potvrdite e-mail adresu
          </h3>
          <div className="img-box">
            <img src={kakoDa2} alt="" />
          </div>
        </div>

        <div className="steps step-3">
          <h3 className="steps-heading-3">
            3. Pepper analizira rad koji ste poslali
          </h3>
          <div className="img-box">
            <img src={kakoDa3} alt="" />
          </div>
        </div>

        <div className="steps step-4">
          <h3 className="steps-heading-4">
            4. Dobijate personalizovani PDF izveštaj
          </h3>
          <div className="img-box">
            <img src={kakoDa4} alt="" />
          </div>
        </div>
      </div>

      
    </div>
    <div className="section-2">
      <div className="text-box">
        <div className="text">
        <h1>Savremena osnovna škola - Stvarno drugačija</h1>
        <p><a href='https://savremena-osnovna.edu.rs' target="_blank">Savremena osnovna škola</a> je mesto gde vaše dete raste, istražuje i razvija se u okruženju koje podstiče radoznalost, samostalnost i ljubav prema učenju. <br/><br/>
Savremeni pristup obrazovanju spaja se sa najvišim međunarodnim standardima - kroz <a href='https://www.savremena-osnovna.edu.rs/nacionalni-program-obrazovanja/' target="_blank">Nacionalni program</a> i <a href='https://www.savremena-osnovna.edu.rs/kombinovani-program-obrazovanja/' target="_blank">Kombinovani Cambridge program</a>, dvojezičnu nastavu i inovativne metode koje pripremaju dete za svet koji se brzo menja. <br/><br/>U učionicama vaše dete uči kroz iskustvo: uz robota Peppera, VR učionice, digitalne alate i praktične projekte koji razvijaju kreativnost, analitičko razmišljanje i saradnju.</p>
        </div>
        <div className="img_1">
          <img src={kakoDa5} alt=""/>
        </div>

      </div>

      <div className="benefit-box">
        <div className="benefit-box-row-1">
          <div className="box-1"></div>
          <div className="box-2"></div>
          <div className="box-3"></div>
        </div>
        <div className="benefit-box-row-2">
          <div className="box-1"></div>
          <div className="box-2"></div>
          <div className="box-3"></div>
        </div>
      </div>
    </div>
    <div className="cta-section">
      <div className="cta-box">
        <h1>Upis je u toku!<br/> Stvarno drugačije obrazovanje za generacije koje menjaju svet.<br/> <a href="https://www.savremena-osnovna.edu.rs/prijava/">Prijavite se →</a></h1>
      </div>
    </div>
    <div className="footer">
      <div className="logo-box">
        <img src={logoHeaderWhite} alt="" />
      </div>
      <div className="info">
        <span>Bulevar heroja sa Košara 17,</span>
        <span>Novi Beograd</span>
        <span><a href="tel:+381114011222">011/40-11-222</a></span>
        <span><a href="tel:+381621918056">062/19-18-056</a></span>
        <span><a href="email:office@savremena-osnovna.edu.rs">office@savremena-osnovna.edu.rs</a></span>
        <span><a href="savremena-osnovna.edu.rs">savremena-osnovna.edu.rs</a></span>
      </div>
    </div>
        
    </>
  )
}

export default Home